import * as yup from "yup";

const hasValue = (value) => value !== undefined && value !== null && String(value).trim() !== "";

// Not read/fired anywhere yet — carried through validation and the engine
// so the data is already in place once a GA event trigger is built to
// consume it. Purely optional metadata, no shape enforced beyond "strings".
const gaEventSchema = yup.object({
  segmentName: yup.string().nullable(),
  campaignName: yup.string().nullable(),
  bannerName: yup.string().nullable(),
}).nullable();

const componentSchema = yup.object({
  contentId: yup.string().nullable(),
  action: yup
    .string()
    .oneOf(["add", "replace", "", null], "component action must be add, replace, or blank")
    .nullable(),
  position: yup
    .string()
    .oneOf(["top", "bottom", "left", "right", "", null], "component position must be top, bottom, left, right, or blank")
    .nullable(),
  content: yup
    .mixed()
    .test("content-required", "component content is required", hasValue)
    .required(),
  gaEvent: gaEventSchema,
});

export const ruleSchema = yup.object({
  sectionId: yup
    .mixed()
    .test("section-id-required", "sectionId is required", hasValue)
    .required(),
  action: yup
    .string()
    .oneOf(["add", "replace", "", null], "action must be add, replace, or blank")
    .nullable(),
  position: yup
    .string()
    .oneOf(["top", "bottom", "left", "right", "", null], "position must be top, bottom, left, right, or blank")
    .nullable(),
  memberIdentifier: yup.mixed().nullable(),
  sectionType: yup.string().nullable(),
  // Accepts both casings — every other field is lowercase-first, "Title"
  // was an early inconsistency that authored files still use in places.
  title: yup.string().nullable(),
  // Only meaningful for section-level add/replace: renders the override as
  // an edge-to-edge full-width image vs. the padded-container-with-carousel
  // layout used by every other section.
  fullWidth: yup.boolean().nullable(),
  component: yup.array().of(componentSchema).default([]),
});
